export enum EmployeeSelectionModeType {
  ANY_PERSON_FIRST = 'any_person_first',
  SPECIFIC_ONLY = 'specific_only',
  AUTO_ASSIGN = 'auto_assign'
}
